module.exports = __webpack_public_path__ + "img/Unidad4-4.69fe84d6.png";